export const gaEvent = (...args) => {
  if (typeof ga !== 'undefined') {
    ga('send', 'event', ...args);
  }
};
